import { Col, Row, Card } from "antd";
import { PlayCircleOutlined } from "@ant-design/icons";

export const Hero = () => {
  return (
    <Row
      style={{
        alignItems: "center",
        justifyContent: "center",
        background: "rgb(225, 225, 219)",
        paddingTop: "15px",
        textAlign: "center",
        backgroundImage: `url("https://images.pexels.com/photos/11733074/pexels-photo-11733074.jpeg?cs=srgb&dl=pexels-kelly-11733074.jpg&fm=jpg")`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width: "100%",
        minHeight: "90vh",
        maxWidth: "1600px",
        margin: "0px auto",
      }}
    >
      <Col xs={24} sm={24} md={12}>
        <div
          style={{
            color: "white",
            fontWeight: "700",
            maxWidth: "520px",
            textAlign: "left",
            margin: "10px 10%",
          }}
          className="hero-title"
        >
          <span style={{ background: "black", padding: "5px" }}>
            Broadcast & Infrastucture Service Providers
          </span>
        </div>
        <Card
          bordered={true}
          style={{
            lineHeight: "1",
            letterSpacing: ".56px",
            margin: "10px 10%",
            boxShadow: " 10px 10px 1px #000",
          }}
          className="hero-description"
        >
          <span>
            Peoples Media Network is operates the Buddhist Radio and Television
            Network in Sri Lanka. The company provides owns and managers a
            network of transmission site across the country.
          </span>
        </Card>
        <br></br>
        <a href="#examples">
          <Card
            bordered={true}
            style={{
              fontWeight: "700",

              margin: "10px 10%",
              background: "white",
              color: "black",
              textAlign: "left",
              boxShadow: " 10px 10px 1px #000",
              display: "block",
            }}
            className="hero-link"
          >
            <div>
              <span>View Property Pages</span>
              <span style={{ float: "right" }}>
                <PlayCircleOutlined style={{ verticalAlign: "text-bottom" }} />
              </span>
            </div>
          </Card>
        </a>
      </Col>
    </Row>
  );
};
